import { render, staticRenderFns } from "./RepairComment.vue?vue&type=template&id=150c9987&scoped=true&"
import script from "./RepairComment.vue?vue&type=script&lang=js&"
export * from "./RepairComment.vue?vue&type=script&lang=js&"
import style0 from "./RepairComment.vue?vue&type=style&index=0&id=150c9987&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c9987",
  null
  
)

export default component.exports